import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Button, Input} from 'antd'
import TickersModal from './TickersModal'

import style from './controls.sass'

@inject('store') @observer
class Controls extends Component {
  state = {
    modal: false
  }
  search = (e) => {
    this.props.store.stockFilter.single.filterTickers(e.target.value)
  }
  openModal = () => {
    this.setState({modal: true})
  }
  closeModal = () => {
    this.setState({modal: false})
  }
  deleteTickers = () => {
    this.props.store.stockFilter.single.deleteTickers()
  }
  render() {
    const {stockFilter} = this.props.store
    const {filter, foundTickers, selectedRowKeys} = stockFilter.single
    const {loadingAdditional, loadedFirstNRows} = stockFilter
    return(
      <div styleName='wrapper'>
        <TickersModal
          visible={this.state.modal}
          close={this.closeModal}
        />
        <div>
          <Button
            type='default'
            icon='plus'
            onClick={this.openModal}
            loading={loadingAdditional}
          >
            Add Ticker
          </Button>
          <Button
            type='default'
            icon='delete'
            onClick={this.deleteTickers}
            disabled={!selectedRowKeys.length}
          />
        </div>
        <div>
          {!filter && loadedFirstNRows
            ? <span>Showing first {foundTickers.length} tickers</span>
            : <span>{foundTickers.length} tickers found</span>
          }
          <Input
            placeholder='Search'
            onChange={this.search}
            value={filter}
          />
        </div>
      </div>
    )
  }
}

export default Controls
